<template>
<div class="chapter">
<div class="inner_page">
<p class="C154"><em><a href="#/html/06_Contents#id_1004" id="page_xi">Figures</a></em></p>
<p class="C155"><a href="#/html/12_2__A_Grand_Opportunity__1861_and#page_25">1. Black Refugees 1</a></p>
<p class="C155"><a href="#/html/12_2__A_Grand_Opportunity__1861_and#page_26">2. Black Refugees 2</a></p>
<p class="C155"><a href="#/html/12_2__A_Grand_Opportunity__1861_and#id_981">3. Watch meeting, Dec. 31, 1862, waiting for the hour</a></p>
<p class="C155"><a href="#/html/13_3__The_Forming_of_Black_Regiment#id_982">4. 54th Massachusetts Regiment’s charge on Ft. Wagner</a></p>
<p class="C155"><span href="#/html/14_4__The_Unequal_Pay_Issue#id_983" title="Link target outside of Sample">5. Bounties</span></p>
<p class="C155"><span href="#/html/15_5__Violence_on_Two_Fronts#id_984" title="Link target outside of Sample">6. Public gathering for New York’s first black regiment—the 20th USCT</span></p>
<p class="C155"><span href="#/html/19_9__After_the_War__A_Different_Ki#id_985" title="Link target outside of Sample">7. Grand Review of the Army</span></p>
<p class="C155"><span href="#/html/20_10__Even_Farther_Away_from_Home#id_986" title="Link target outside of Sample">8. Forms of soldier punishment during the Civil War</span></p>
<p class="C155"><span href="#/html/20_10__Even_Farther_Away_from_Home#id_987" title="Link target outside of Sample">9. Members of a black regiment using down time to for reading classes</span></p>
<p class="C155"><span href="#/html/21_11__Home_Again#id_988" title="Link target outside of Sample">10. “Be Citizens in Peace”</span></p>
<p class="C155"><span href="#/html/14_4__The_Unequal_Pay_Issue#id_2" title="Link target outside of Sample">Additional photographs</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 07_List_of_Figures.vue?0458e578